import { render } from "./RegisterDetail.vue?vue&type=template&id=242c9a1e"
import script from "./RegisterDetail.vue?vue&type=script&lang=js"
export * from "./RegisterDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__